class ProductFilter {
  constructor(filterContainer) {
    this.filterContainer = jQuery(filterContainer);
    this.productsContainer = null;

    // Find the products container based on the logic
    this.findProductsContainer();

    if (!this.productsContainer || this.productsContainer.length === 0) {
      console.error('No .mad-products container found for the filter.');
      return;
    }

    // Get the JSON string from the data attribute
    const settingsJson = this.productsContainer.attr('data-products-settings');

    // Parse the JSON string
    try {
      this.initialSettings = JSON.parse(settingsJson);
    } catch (e) {
      console.error('Failed to parse products settings JSON:', e);
      this.initialSettings = {};
    }

    // Get AJAX parameters from $madSettings
    if (
      window.$madSettings &&
      window.$madSettings.shop &&
      window.$madSettings.shop.product_filters
    ) {
      this.ajaxParams = window.$madSettings.shop.product_filters;
    } else {
      console.error('Product filters AJAX parameters not found in $madSettings.');
      return;
    }

    // Bind event handlers
    this.filterContainer.find('input, select').on('change', this.handleFilterChange.bind(this));
  }

  findProductsContainer() {
    const allProductsContainers = jQuery('.mad-products');

    if (allProductsContainers.length === 1) {
      // Only one .mad-products container on the page; use it
      this.productsContainer = allProductsContainers;
      return;
    }

    // Multiple .mad-products containers; start searching from the filter container's parent
    this.productsContainer = this.searchForProductsContainer(this.filterContainer);

    if (!this.productsContainer || this.productsContainer.length === 0) {
      console.error('No .mad-products container found in parent hierarchy.');
    }
  }

  searchForProductsContainer(element) {
    // Base case: if we've reached the body element, abort
    if (element.is('body')) {
      return null;
    }

    // Search for .mad-products within the current parent
    const parent = element.parent();
    const productsContainersInParent = parent.find('.mad-products');

    if (productsContainersInParent.length > 0) {
      // Found one or more .mad-products containers in this parent
      return productsContainersInParent.first();
    } else {
      // Move up to the next parent and continue searching
      return this.searchForProductsContainer(parent);
    }
  }

  handleFilterChange(e) {
    e.preventDefault();

    const filters = this.getFilters();
    const data = {
      ...this.initialSettings,
      ...filters,
      action: this.ajaxParams.endpoint,
      nonce: this.ajaxParams.nonce,
      products_container_selector: this.getProductsContainerSelector(),
    };

    // Show loading indicators
    // window.$madUtil.blockElement(this.productsContainer, {
    //   icon: {
    //     size: 'large',
    //   },
    // });
    window.$madUtil.blockElement(this.filterContainer, {
      icon: {
        size: 'large',
      },
    });

    jQuery.ajax({
      url: this.ajaxParams.ajax_url,
      method: 'POST',
      data: data,
      success: (response) => {
        // window.$madUtil.unblockElement(this.productsContainer);
        window.$madUtil.unblockElement(this.filterContainer);

        if (response.success) {
          // Update fragments
          if (response.data && response.data.fragments) {
            for (const selector in response.data.fragments) {
              const html = response.data.fragments[selector];
              jQuery(selector).html(html);
            }
          }
          // Re-initialize any JS components if necessary
          this.reinitializeComponents();
        } else {
          // Handle error
          console.error('Error:', response.data);
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        // window.$madUtil.unblockElement(this.productsContainer);
        window.$madUtil.unblockElement(this.filterContainer);
        console.error('AJAX Error:', textStatus);
      },
    });
  }

  getProductsContainerSelector() {
    // Generate a unique class or data attribute
    return `.mad-products[data-products-id=${this.productsContainer.data('products-id')}]`;
  }

  getFilters() {
    const filters = {};

    // Collect filter inputs
    this.filterContainer.find('input, select').each((index, element) => {
      const $element = jQuery(element);
      const name = $element.attr('name');
      let value = $element.val();

      if ($element.is(':checkbox')) {
        if (!$element.is(':checked')) {
          value = null;
        }
      }

      if (value && name) {
        // Handle arrays (e.g., checkboxes with same name)
        if (name.endsWith('[]')) {
          const key = name.slice(0, -2);
          if (!filters[key]) {
            filters[key] = [];
          }
          filters[key].push(value);
        } else {
          filters[name] = value;
        }
      }
    });

    return filters;
  }

  reinitializeComponents() {
    // Re-initialize any JS components as needed
    // For example:
    // if (typeof initProductSliders === 'function') {
    //     initProductSliders();
    // }
  }
}

// Initialize the filter on document ready
jQuery(document).ready(() => {
  jQuery('.mad-product-filters').each((index, element) => {
    new ProductFilter(element);
  });
});
